<template>
  <div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%"
        border
        v-loading="listLoading"
        size="small"
        @selection-change="selsChange"
        @cell-click="toggleSelection"
        @header-click="selsAll"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间"></el-table-column>
    </el-table>
<!--    <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">-->
<!--    </el-pagination>-->
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >返回</el-button>
      <el-button type="primary" @click="sendConfirm" v-loading="submitLoading">发送</el-button>
    </div>
  </div>
</template>

<script>
import {getFormData, postFormData} from "@/api/api";
import { getVoucherSysList, sendVoucherByUser } from "@/api/url";

export default {
  name: "voucherAwardDialog",
  props: {
    value: Object
  },
  data() {
    return {
      userIdArray: this.value.idArray,
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      submitLoading: false,

      idArray: [],
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage() {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },
    //页面参数
    getPageParam(page) {
      let param = {};
      // param['pageNum'] = page;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getVoucherSysList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result;
          // this.totalRow = result['total'];
          // this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    sendConfirm() {
      if(this.idArray.length > 0) {
        this.$confirm('确认给选中的用户发送代金券', {
          type: 'warning'
        }).then(() => {
          let _this = this;
          this.submitLoading = true;
          let param = {};
          param['idArr'] = this.userIdArray;
          param['voucherSysIdArr'] = this.idArray;
          postFormData(sendVoucherByUser,param).then(function(data) {
            let { code, msg } = data;
            if(code == 200) {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              })
            } else {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              })
            }
            _this.submitLoading = false;
            _this.$emit('close');
            _this.$emit('confirm');
          })
              .catch(function() {
                _this.submitLoading = false;
              })
        })
            .catch(() => {})
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一张代金券进行发送',
          type: 'warning'
        })
      }
    },

    toggleSelection(row, column, cell, event) {
      if (column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
    }

  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
